export const COUPON_STORAGE_KEY = 'javiland_applied_coupon';

export function readStoredCoupon() {
  try {
    const raw = sessionStorage.getItem(COUPON_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed && parsed.code ? parsed : null;
  } catch {
    return null;
  }
}

export function writeStoredCoupon(coupon) {
  if (coupon && coupon.code) {
    sessionStorage.setItem(COUPON_STORAGE_KEY, JSON.stringify(coupon));
  } else {
    sessionStorage.removeItem(COUPON_STORAGE_KEY);
  }
}

export function calculateCouponDiscount(coupon, subtotalAmount, shippingAmount = 0) {
  if (!coupon) return 0;
  const minPurchase = Number(coupon.minPurchase || 0);
  if (minPurchase > 0 && subtotalAmount < minPurchase) return 0;

  const type = String(coupon.discountType || '').toLowerCase();
  const value = Number(coupon.discountValue || 0);
  const maxDiscount = coupon.maxDiscount != null ? Number(coupon.maxDiscount) : null;

  let discount = 0;
  if (type === 'percentage' || type === 'percent') {
    discount = (subtotalAmount * value) / 100;
  } else if (type === 'fixed' || type === 'amount') {
    discount = value;
  } else if (type === 'shipping_free') {
    discount = shippingAmount;
  }

  if (maxDiscount != null && maxDiscount > 0) {
    discount = Math.min(discount, maxDiscount);
  }
  return Math.max(0, Math.min(discount, subtotalAmount + shippingAmount));
}
